import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';


import { ApiError, MessageService } from '../../../../../core';
import { LeadClassificacao } from '../lead-classificacao';
import { GrupoClassificacaoClassificavelFormComponent } from '../../../../grupo-classificacao/classificavel/form';
import { GrupoClassificacao } from '../../../../grupo-classificacao';
import { GrupoClassificacaoClassificacao } from '../../../../grupo-classificacao/classificacao';
import { GrupoClassificacaoSituacaoHttpService } from '../../../../grupo-classificacao/situacao';

@Component({
    selector: 'sgt-lead-classificacao-form',
    templateUrl: './lead-classificacao-form.component.html',
    styleUrls: ['./lead-classificacao-form.component.less']
})
export class LeadClassificacaoFormComponent {
    /** ID do Lead */
    @Input() idLead: number;

    /** Classificações do Lead */
    @Input() entities: LeadClassificacao[];
    /** Ao alterar as classificações do Lead */
    @Output() entitiesChange = new EventEmitter<LeadClassificacao[]>();

    @ViewChild('form') form: GrupoClassificacaoClassificavelFormComponent;

    constructor(private messageService: MessageService,
                private grupoClassificacaoSituacaoHttpService: GrupoClassificacaoSituacaoHttpService) { }

    /** Carrega o grupo de classificação de cadastro de clientes que é o mesmo utilizado para os Leads */
    private loadGrupoClassificacao(): Promise<GrupoClassificacao> {
        return new Promise<GrupoClassificacao>((resolve, reject) => {
            this.grupoClassificacaoSituacaoHttpService.loadCadastroCliente()
                .pipe(
                    take(1)
                )
                .subscribe(
                    grupoClassificacao => resolve(grupoClassificacao),
                    (error: ApiError) => reject(error)
                );
        });
    }

    /** Insere uma classificação no lead através da classificação do grupo */
    private insertClassificacao(grupoClassificacaoClassificacao: GrupoClassificacaoClassificacao) {
        const entity = new LeadClassificacao();
        entity.idLead = this.idLead;

        // Setando as informações do grupo de classificação na entidade
        this.form.insertClassificacao(entity, grupoClassificacaoClassificacao);

        this.entities.push(entity);
    }

    /** Insere classificações do grupo de classificação de cadastro de clientes no lead */
    insert(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.loadGrupoClassificacao()
                .then(grupoClassificacao => {
                    if (grupoClassificacao) {
                        grupoClassificacao.classificacoes?.forEach(grupoClassificacaoClassificacao => this.insertClassificacao(grupoClassificacaoClassificacao));
                    } else {
                        this.entities = [];
                    }

                    this.entitiesChange.emit(this.entities);
                    resolve();
                })
                .catch((error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao adicionar as classificações no novo Lead', error);
                    reject();
                });
        });
    }

    /** Verifica se as classificações estão válidas */
    isValid(): boolean {
        return this.form.isValid();
    }
}
